<template>
  <div class="card p-3 shadow-sm">
    <div class="container-fluid my-4">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h4 class="fw-semibold text-primary m-0">Cuentas pendientes de pagar de restaurante</h4>
        <button
          class="btn btn-danger btn-sm"
          @click="descargarPDF"
          :disabled="mesas.length === 0"
          title="Descargar PDF"
        >
          <i class="bi bi-file-pdf me-1"></i> Descargar PDF
        </button>
      </div>

      <!-- Filtro por fecha y hora -->
      <div class="card shadow-sm mb-3">
        <div class="card-body py-2">
          <div class="row g-2 align-items-end">
            <div class="col-md-2">
              <label class="form-label small mb-1">Fecha Inicio</label>
              <input type="date" v-model="filtros.fechaInicio" class="form-control form-control-sm" />
            </div>
            <div class="col-md-2">
              <label class="form-label small mb-1">Hora Inicio</label>
              <input type="time" v-model="filtros.horaInicio" class="form-control form-control-sm" />
            </div>
            <div class="col-md-2">
              <label class="form-label small mb-1">Fecha Fin</label>
              <input type="date" v-model="filtros.fechaFin" class="form-control form-control-sm" />
            </div>
            <div class="col-md-2">
              <label class="form-label small mb-1">Hora Fin</label>
              <input type="time" v-model="filtros.horaFin" class="form-control form-control-sm" />
            </div>
            <div class="col-md-2 d-flex gap-1">
              <button @click="cargarCuentas" class="btn btn-primary btn-sm">
                <i class="bi bi-search"></i> Buscar
              </button>
              <button @click="limpiarFiltros" class="btn btn-secondary btn-sm">
                <i class="bi bi-x"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- 📋 Listado -->
      <div v-if="mesas.length" class="row g-3">
        <div
          v-for="mesa in mesas"
          :key="mesa.mesa_numero"
          class="col-12"
        >
          <div class="mesa-card border rounded shadow-sm p-3">
            <!-- Encabezado mesa -->
            <h5 class="fw-semibold mb-3">Mesa #{{ mesa.mesa_numero }}</h5>

            <!-- Pedidos y Cuentas -->
            <div v-for="pedido in mesa.pedidos" :key="pedido.IdPedido" class="mb-3">
              <h6 class="text-secondary fw-semibold mb-2">
                🧾 Pedido #{{ pedido.IdPedido }}
                <span
                  class="badge ms-2"
                  :class="pedido.EstadoPedido === 1 ? 'bg-success' : 'bg-warning text-dark'"
                >
                  {{ pedido.EstadoPedido === 1 ? 'Cerrado' : 'Abierto' }}
                </span>
              </h6>

              <div
                v-for="cuenta in pedido.cuentas"
                :key="cuenta.IdCuentaPedido"
                class="border rounded p-2 mb-2 small shadow-sm bg-light d-flex justify-content-between align-items-center flex-wrap"
              >
                <div class="me-2">
                  <strong>{{ cuenta.NombreCuenta }}</strong><br />
                  <span class="text-muted">
                    Total: Q{{ parseFloat(cuenta.Total).toFixed(2) }}
                  </span><br />
                  <span class="text-muted">
                    Pendiente: Q{{ parseFloat(cuenta.SaldoPendienteCuenta).toFixed(2) }}
                  </span>
                </div>
                <div class="text-end mt-1">
                  <span
                    class="badge mb-1"
                    :class="cuenta.Estado === 0 ? 'bg-danger' : 'bg-success'"
                  >
                    {{ cuenta.Estado === 0 ? 'Pendiente' : 'Pagada' }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-else class="text-center text-muted fs-6 mt-4">
        No se encontraron cuentas pendientes.
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { API_URL } from '@/config/config'

export default {
  name: 'CuentasMesas',
  data() {
    return {
      mesas: [],
      actualizando: false,
      filtros: {
        fechaInicio: '',
        horaInicio: '00:00',
        fechaFin: '',
        horaFin: '23:59',
      },
    }
  },
  methods: {
    limpiarFiltros() {
      this.filtros = {
        fechaInicio: '',
        horaInicio: '00:00',
        fechaFin: '',
        horaFin: '23:59',
      }
      this.cargarCuentas()
    },
    async cargarCuentas() {
      try {
        this.actualizando = true
        const params = {}
        if (this.filtros.fechaInicio && this.filtros.fechaFin) {
          params.fecha_inicio = this.filtros.fechaInicio
          params.hora_inicio = this.filtros.horaInicio
          params.fecha_fin = this.filtros.fechaFin
          params.hora_fin = this.filtros.horaFin
        }
        const { data } = await axios.get(`${API_URL}/cuentas-mesa`, { params })
        this.mesas = data
      } catch (err) {
        console.error('Error al cargar las cuentas por mesa:', err)
      } finally {
        this.actualizando = false
      }
    },
    async descargarPDF() {
      if (this.mesas.length === 0) {
        return;
      }

      try {
        const response = await axios.get(`${API_URL}/cuentas-mesa-pdf`, {
          responseType: 'blob'
        });

        const blob = new Blob([response.data], { type: 'application/pdf' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        const fecha = new Date().toISOString().split('T')[0];
        link.download = `Cuentas_Pendientes_Restaurante_${fecha}.pdf`;
        link.click();
        window.URL.revokeObjectURL(link.href);
      } catch (error) {
        console.error('Error descargando PDF:', error);
      }
    }
  },
  mounted() {
    this.cargarCuentas()
  },
}
</script>

<style scoped>
.mesa-card {
  background-color: #fff;
  transition: transform 0.2s ease;
}
.mesa-card:hover {
  transform: translateY(-2px);
}
.mesa-header h6 {
  font-size: 0.95rem;
}
.mesa-body {
  background-color: #fafafa;
  border-top: 1px solid #ddd;
}
.badge {
  font-size: 0.75rem;
}
</style>
